import React, { createContext, useContext } from 'react';
export var NuiContext = createContext({
  themeName: 'nab'
});
export var useNui = function useNui() {
  return useContext(NuiContext);
};